import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';
import { MutedText, SmallText } from '@/components/ui/typography';
import type { GroupChildFloat } from '@/lib/blocks/layout/group-layout';
import { SettingRow } from './fields';

const FLOAT_OPTIONS: Array<{ value: GroupChildFloat | null; label: string }> = [
  { value: null, label: 'None' },
  { value: 'left', label: 'Float Left' },
  { value: 'right', label: 'Float Right' },
];

interface FloatWrapControlProps {
  value: GroupChildFloat | null;
  onChange: (value: GroupChildFloat | null) => void;
  description: string;
  disabled?: boolean;
  layout?: 'stacked' | 'row';
  buttonClassName?: string;
}

export function FloatWrapControl({
  value,
  onChange,
  description,
  disabled = false,
  layout = 'stacked',
  buttonClassName,
}: FloatWrapControlProps) {
  const buttons = (
    <ButtonGroup>
      {FLOAT_OPTIONS.map((option) => {
        const selected = value === option.value;

        return (
          <Button
            key={option.label}
            variant={selected ? 'solid' : 'outline'}
            colorScheme="secondary"
            className={buttonClassName}
            aria-pressed={selected}
            onClick={() => onChange(option.value)}
            disabled={disabled}
          >
            {option.label}
          </Button>
        );
      })}
    </ButtonGroup>
  );

  if (layout === 'row') {
    return (
      <SettingRow title="Wrap" description={description}>
        {buttons}
      </SettingRow>
    );
  }

  return (
    <div className="space-y-2">
      <SmallText className="font-semibold text-foreground">Wrap</SmallText>
      <MutedText className="text-xs leading-5">{description}</MutedText>
      {buttons}
    </div>
  );
}
